import React from 'react';
import { useDispatch } from 'react-redux';
import { openPopup } from '../../../../components/Popup/_components/WrapperPopup';
import { callEventBiology, getBiology, useBiology } from '../../../../contexts/PlanOperationContext/Biology';
import { KEY_STORAGE, OPERATION_TYPE } from '../../../../util/varibles/constants';
import { checkZero } from '../../../../util/varibles/global';
import { IPropsChildren, ISite } from '../../../../util/varibles/interface';
import { planOpActions } from '../../reducer';
import Location from "../_components/Location";
import { deleteDragEl, KEY_SPLIT, MODE_DRAG } from '../constants';
import styles from './style.module.scss';

const onChangePosition = (e: any) => {
    const position = [e.screenX, e.screenY].join(KEY_SPLIT);
    localStorage.setItem(KEY_STORAGE.POSITION, position);
}

const createDragEl = (data: ISite) => {
    const el = openPopup(<div className={styles.dragView}>
        <div className="flex items-center gap-[2px] leadding-[18px] flex-wrap">
            {`P${checkZero(data.prod_area)}`}
            <span>|</span>
            <Location source={[data.name]} style={{ fontSize: '15px', fontWeight: 500, lineHeight: '18px' }} />
        </div>
    </div>);
    el.style.position = 'absolute';
    el.style.zIndex = '9999';
    el.style.display = 'none';
    return el;
}

const areEqual = (prevProps: IProps, nextProps: IProps) => {
    const isChange = prevProps.isError !== nextProps.isError
        || prevProps.message !== nextProps.message
        || prevProps.messageText !== nextProps.messageText
        || JSON.stringify(prevProps.style) !== JSON.stringify(nextProps.style)
        || JSON.stringify(prevProps.data) !== JSON.stringify(nextProps.data)

    return !isChange
};

interface IProps extends IPropsChildren {
    data: any
    isError?: boolean
    message?: any
    messageText?: any
    style?: any

    onContext?(e: React.MouseEvent<HTMLDivElement>): void
}

const Card: React.FC<IProps> = React.memo(props => {
    const {
        data,
        isError = false,
        message,
        messageText,
        style,
        children,
        onContext
    } = props;
    const dispatch = useDispatch();
    const [isAllowedToCreate, set] = useBiology(state => state.isAllowedToCreate);
    const get = getBiology();
    const { updateDragEl } = callEventBiology();

    function handleMouseDown(e: any) {
        if (e.button !== 0)
            return;

        if (isError)
            return;

        document.addEventListener('mouseup', handleMouseUp);
        document.body.setAttribute('data-is-prevent-select', 'true');

    }

    const handleMouseUp = () => {
        document.removeEventListener('mouseup', handleMouseUp);
        document.body.setAttribute('data-is-prevent-select', 'false');
    };

    const handleContextMenu = (e: any) => {
        e.preventDefault();
        if (onContext)
            onContext(e);
    }

    const handleDragStart = () => {
        const el = createDragEl(data);
        localStorage.setItem(KEY_STORAGE.REQUIRE_OPERATION_TYPE, JSON.stringify([OPERATION_TYPE.SERVICE]));
        localStorage.setItem(KEY_STORAGE.UNITS_SELECTED, JSON.stringify({}));
        set({ dragEl: el });

        document.body.style.overflow = 'hidden';
        document.body.addEventListener('dragover', handleDragOver);
        document.body.addEventListener('drop', handleDrop);
    }

    const handleDragOver = (e: MouseEvent) => {
        const { pageX, pageY } = e;
        updateDragEl(pageX, pageY);
        onChangePosition(e);
        e.preventDefault();
    }

    const handleDrop = (e: MouseEvent) => {
        const { dragEl } = get()
        deleteDragEl(dragEl);
        dispatch(planOpActions.togglePopupOperation({ e, location: data }))
    }

    const handleDragEnd = (e: React.DragEvent) => {
        const target = e.currentTarget as HTMLDivElement;
        target.style.cursor = 'grab';
        const mode = MODE_DRAG.END;
        localStorage.setItem(KEY_STORAGE.MODE_DRAG, mode);
        document.body.style.overflow = '';
        document.body.removeEventListener('dragover', handleDragOver);
        document.body.removeEventListener('drop', handleDrop);
        const { dragEl } = get()
        deleteDragEl(dragEl);
    }

    if (!isAllowedToCreate) {
        return <div
            className={styles.card}
            style={style}
            onContextMenu={handleContextMenu}
        >
            {children}
            <div className={styles['drag-view']} style={{ cursor: "default" }}>
                {message && <div className={styles.note} title={messageText ? messageText : message}>{message}</div>}
            </div>
        </div>
    }

    return <div
        className={styles.card}
        onMouseDown={handleMouseDown}
        onContextMenu={handleContextMenu}
        style={style}
    >
        {children}
        <div
            className={styles['drag-view']}
            draggable={!isError}
            onDragStart={(e) => !isError ? handleDragStart() : null}
            onDragEnd={handleDragEnd}
        >
            {message && <div className={styles.note} title={messageText ? messageText : message}>{message}</div>}
        </div>
    </div>;
}, areEqual);

export default Card;